<template>
  <div id="app">
    <vue-confirm-dialog></vue-confirm-dialog>
    <navbar />
    <sidebar />
    <router-view/>
    <Footer/>
  </div>
</template>

<script>
import Navbar from '@/components/Navbar'
import Footer from '@/components/Footer'
import Sidebar from '@/components/Sidebar'
export default {
  name: 'App',
  components: {
    Navbar,
    Footer,
    Sidebar
  },
  watch: {
    $route: {
      immediate: true,
      handler (to, from) {
        document.title = 'Gmnanashi - ' + to.meta.title
      }
    }
  }
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/App.vue